var _circle, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyInCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 47,
    fill: "#8ECDD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3163_22830)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 39,
    fill: "#73A6AD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2812 60.4375C67.3055 60.4375 73 54.743 73 47.7188C73 40.6945 67.3055 35 60.2812 35C53.257 35 47.5625 40.6945 47.5625 47.7188C47.5625 49.0701 47.7721 50.3781 48.1623 51.5994L36.5059 63.2559C36.1807 63.5811 36 64.0219 36 64.4844V70.2656C36 71.2268 36.7732 72 37.7344 72H43.5156C44.4768 72 45.25 71.2268 45.25 70.2656V67.375H48.1406C49.1018 67.375 49.875 66.6018 49.875 65.6406V62.75H52.7656C53.2281 62.75 53.6689 62.5693 53.9941 62.2441L56.4006 59.8377C57.6219 60.2279 58.9299 60.4375 60.2812 60.4375ZM63.1719 41.9375C63.9385 41.9375 64.6738 42.242 65.2159 42.7841C65.758 43.3262 66.0625 44.0615 66.0625 44.8281C66.0625 45.5948 65.758 46.33 65.2159 46.8721C64.6738 47.4142 63.9385 47.7188 63.1719 47.7188C62.4052 47.7188 61.67 47.4142 61.1279 46.8721C60.5858 46.33 60.2812 45.5948 60.2812 44.8281C60.2812 44.0615 60.5858 43.3262 61.1279 42.7841C61.67 42.242 62.4052 41.9375 63.1719 41.9375Z",
    fill: "#F2F3F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3163_22830",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_3163_22830"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyInCircle);
export default __webpack_public_path__ + "static/media/key-in-circle.b5bbb21940946ae45a05d25d148b71e5.svg";
export { ForwardRef as ReactComponent };